import { renderParagraphContent, type BlockComponentProps } from "./shared"
import { sanitizeHtml } from "@/lib/sanitizeHtml"

export function ParagraphBlock({ content, resolved }: BlockComponentProps) {
  const doc = content?.content as Record<string, unknown> | null
  const textFallback = content?.text as string | undefined
  const html = renderParagraphContent(doc)
  const hasContent = html && html.trim().length > 0
  const hasText = textFallback && String(textFallback).trim().length > 0
  if (!hasContent && !hasText) return null
  const paraSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8"
  return (
    <section className={paraSectionClass} style={resolved.sectionStyle}>
      {/* NOS-221: base `prose` (16px) — matches the pre-plugin inherited size;
          prose-sm would shrink post bodies to 14px now that the plugin is real */}
      <div className="prose max-w-none mx-auto">
        {hasContent ? (
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(html!) }} />
        ) : (
          <p className="text-muted-foreground leading-relaxed">{textFallback}</p>
        )}
      </div>
    </section>
  )
}
